import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";

import Button from "../../Ui/Button";
import Aux from "../../../hoc/Auxilliary";
import loginStyle from "./loginItems.module.css";
import { callMsGraph } from "./graph";
import localizedStrings from "../../../utils/localize";
import { SSOLoginRequest } from "../../../app/authConfig";
import { isObjectEmpty } from "../../../utils/general";
import {
  SSOloginRequestAPI,
  isLoggedInUpdate,
  setErrorMessage,
} from "../../../reduxSlices/loginSlice";
import SnackBar from "../../SnackBar";
import Backdrop from "../../Backdrop";

const SSOLogin = (props) => {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  const ssologinRequestData = useSelector(
    (state) => state.loginRequest.ssologinRequestData,
  );

  const errorMessage = useSelector((state) => state.loginRequest.errorMessage);

  if (!isObjectEmpty(ssologinRequestData)) {
    let responseData = ssologinRequestData;
    window.localStorage.setItem("x-auth-token", responseData.token);
    window.localStorage.setItem(
      "x-auth-fullname",
      responseData.data.displayName,
    );
    window.localStorage.setItem(
      "x-auth-contactId",
      responseData.data.contactid,
    );
    window.localStorage.setItem("x-auth-email", responseData.data.mail);
    window.localStorage.setItem("x-auth-mobile", responseData.data.mobilePhone);
    window.localStorage.setItem("ses_usesso", true);
    window.localStorage.setItem("isUserLoggedIn", true);
    dispatch(isLoggedInUpdate(true));
    props.props.history.push({
      pathname: "/home",
    });
  }

  const dataFetchingStatus = useSelector(
    (state) => state.loginRequest.dataFetchingStatus,
  );

  const handleClick = async () => {
    let res = await instance.loginPopup(SSOLoginRequest).catch((e) => {});
    if (res.account && isObjectEmpty(res.account.length > 0)) {
      await instance
        .acquireTokenSilent({
          ...SSOLoginRequest,
          account: res.account,
        })
        .then((response) => {
          callMsGraph(response.accessToken).then((response) =>
            setGraphData(response),
          );
        });
    }
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = errorMessage.error;
      setShowSnackBar(status);
    }
  }, [errorMessage]);

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(setErrorMessage({}));
  };

  useEffect(() => {
    if (graphData != null) {
      dispatch(SSOloginRequestAPI(graphData));
    }
  }, [graphData]);

  return (
    <Aux>
      <SnackBar
        open={showSnackBar.status}
        message={showSnackBar.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <div className={loginStyle.loginSSOContent}>
        <Button onClick={handleClick}>
          {localizedStrings.login.logininwithAD}
        </Button>
      </div>
    </Aux>
  );
};

export default SSOLogin;
